import { liteClient } from "algoliasearch/lite";

// Algolia credentials - 環境変数から取得
const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
const ALGOLIA_SEARCH_API_KEY = process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY;
const ALGOLIA_INDEX_NAME_RAW = process.env.REACT_APP_ALGOLIA_INDEX_NAME;

if (!ALGOLIA_APP_ID) {
  throw new Error("REACT_APP_ALGOLIA_APP_ID is not set in environment variables");
}
if (!ALGOLIA_SEARCH_API_KEY) {
  throw new Error("REACT_APP_ALGOLIA_SEARCH_API_KEY is not set in environment variables");
}
if (!ALGOLIA_INDEX_NAME_RAW) {
  throw new Error("REACT_APP_ALGOLIA_INDEX_NAME is not set in environment variables");
}

// インデックス名は環境変数から取得（開発: topics_dev / 本番: topics）
export const ALGOLIA_INDEX_NAME = ALGOLIA_INDEX_NAME_RAW;

export const algoliaClient = liteClient(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);
